export const LOOKUP_FILTERS_LOADING = "LOOKUP_FILTERS_LOADING";
export const LOOKUP_FILTERS_LOADED = "LOOKUP_FILTERS_LOADED";